import { useAtom } from 'jotai';
import { useMemo } from 'react';
import { incaAccessor } from '@cancercentrum/inca';
import { useErrandInternalInfo } from '../../../hooks/useErrandInternalInfo';
import { useRowModel } from '../../../hooks/useRowModel';
import { requiredAtom } from '../atoms';
export default function useConnectionState() {
    const row = useRowModel();
    const inca = incaAccessor();
    const [isRequired] = useAtom(requiredAtom);
    const [getInternalModeInformation] = useErrandInternalInfo('mode');
    const [getInternalInfoIsNewRegistration] = useErrandInternalInfo('CONNECTION_ISNEWREGISTRATION', {
        isNewRegistration: false
    });
    const isNewRegistration = getInternalInfoIsNewRegistration()?.isNewRegistration;
    const mode = getInternalModeInformation()?.mode;
    const getConnectedPostId = useMemo(()=>{
        if (row.$extra.parentRegisterRecordId) return row.$extra.parentRegisterRecordId; // RowModel.$extra is any
        if (row.$extra.registerRecordId) return row.$extra.registerRecordId; // RowModel.$extra is any
        if (isNewRegistration) return 'NEW_PRIMARY_TUMOR';
        return null;
    }, [
        row.$extra.parentRegisterRecordId,
        row.$extra.registerRecordId,
        isNewRegistration
    ]);
    return {
        connectedPostId: getConnectedPostId,
        mode: mode,
        isConnected: !!row.$extra.registerRecordId || !!row.$extra.parentRegisterRecordId || isNewRegistration,
        isDelsparat: inca.errand?.errandTags?.includes('Delsparat'),
        isRequired: isRequired
    };
}
